import { SimpleGraphContainerWithGreyBackground } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphViewContainer';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { ArdoqLoaderComponent, LoaderColor, LoaderSize } from '@ardoq/loader';
import { ResizablePageBody } from '@ardoq/page-layout';
import { FlexBox } from '@ardoq/layout';
import type { I18nLocale } from '@ardoq/i18n';

type MetamodelLoaderProps = {
  isMetaModelLoaded: boolean;
  children: React.ReactElement;
  closeViewpointBuilder: () => void;
  i18nLocale: I18nLocale;
};

export const WithMetamodelLoader = ({
  isMetaModelLoaded,
  closeViewpointBuilder,
  children,
  i18nLocale,
}: MetamodelLoaderProps) => {
  if (!isMetaModelLoaded) {
    return (
      <ResizablePageBody
        skipPadding
        rightContent={null}
        footerContent={
          <ViewpointBuilderFooter
            closeViewpointBuilder={closeViewpointBuilder}
            i18nLocale={i18nLocale}
          />
        }
      >
        <MetaModelLoader />
      </ResizablePageBody>
    );
  }

  return children;
};

export const MetaModelLoader = () => {
  return (
    <SimpleGraphContainerWithGreyBackground>
      <FlexBox flex={1} justify="center" align="center">
        <ArdoqLoaderComponent
          size={LoaderSize.MEDIUM}
          loaderColor={LoaderColor.BRAND}
        />
      </FlexBox>
    </SimpleGraphContainerWithGreyBackground>
  );
};
